import React, { useState } from 'react';
import { Link, NavigateFunction, useNavigate } from 'react-router-dom';
import { Button, Checkbox, FormControlLabel, Grid, Paper, TextField, Typography } from '@mui/material';
import { login } from '../../services/auth-service'
// import home from './../home/Home'

const LoginPage: React.FC = () => {

    let navigate: NavigateFunction = useNavigate();

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState<boolean>(false);
    const [message, setMessage] = useState<string>("");

    const paperStyle: React.CSSProperties = {
        padding: 60,
        height: 'auto',
        width: 400,
        margin: "50px auto"
    };

    const handleLogin = () => {
        console.log("submitLogin : username="+username+ ", pass="+password);

        setMessage("");
        setLoading(true);
    
        login(username, password).then(
          () => {
            navigate("/quiz/QuizHome");
            window.location.reload();
          },
          (error) => {
            const resMessage =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
    
            setLoading(false);
            setMessage(resMessage);
          }
        );
    } 
      
    return (
        <Grid container justifyContent="center">
            <Paper elevation={10} style={paperStyle}>
            <div style={{ textAlign: 'center' }}>
                    <h1>welcome !!! sagar powar new</h1>
                    <Typography>
                        <Link to={''}>Sign in</Link> to Continue
                    </Typography>
                    <div style={{ marginBottom: '20px' }} />
                </div>
                
                <TextField
                    label="Username"
                    placeholder="Enter Username"
                    variant="outlined"
                    id="username"
                    //onFocus={clearUsernameFieldError}
                    fullWidth
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                />

                <div style={{ marginBottom: '10px' }} />

                <TextField
                    label="Password"
                    placeholder="Enter Password"
                    type="password"
                    id="pass"
                    variant="outlined"
                    fullWidth
                    value={password}
                    //onFocus={clearPasswordFieldError} // Add onFocus event handler
                    onChange={(e) => setPassword(e.target.value)}
                />
                <div style={{ marginBottom: '20px' }} />
                <Grid container alignItems="center" justifyContent="space-between">
                    <Grid item>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    name="checkedB"
                                    color="primary"
                                />
                            }
                            label="Remember me"
                        />
                    </Grid>
                    <Grid item>
                    <Typography>
                       <Link to='/login/Forgetpassword'>Forgot password?</Link>
                    </Typography>
                    </Grid>
                </Grid>
                <div style={{ marginBottom: '20px' }} />
                <Button 
                    type='submit' 
                    variant="contained" 
                    color="primary" 
                    fullWidth 
                    onClick={handleLogin}
                    >
                        Sign in
                </Button>
                <div style={{ marginBottom: '20px' }} />
                <div style={{ textAlign: 'center' }}>
                    <Typography>
                        New user ?
                        <Link to='/login/SignUp'>Sign Up</Link> 
                    </Typography>
                </div>
            </Paper>
        </Grid>
    )
}

export default LoginPage;
